<template>
  <b-modal
    v-model="showModal"
    :title="`Positive ID Enrollment — ${displayName || userName}`"
    size="lg"
    ok-only
    ok-title="Close"
    ok-variant="secondary"
    no-fade
  >
    <PositiveIdEnrollmentForm v-if="showModal" :user-name="userName" />
  </b-modal>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PositiveIdEnrollmentForm from '@/components/Common/PositiveIdEnrollmentForm.vue';

@Component({ name: 'PositiveIdEnrollmentModal', components: { PositiveIdEnrollmentForm } })
export default class PositiveIdEnrollmentModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, required: true }) readonly userName!: string;
  @Prop({ type: String, default: '' }) readonly displayName!: string;

  private showModal = false;

  @Watch('show', { immediate: true })
  onShowChanged(value: boolean): void {
    this.showModal = value;
  }

  @Watch('showModal')
  onShowModalChanged(value: boolean): void {
    if (!value && value !== this.show) this.$emit('update:show', false);
  }
}
</script>
